module.exports = __webpack_public_path__ + "img/wechat.288eda1d.png";